import axios from "axios";
import dayjs from "dayjs";
import { BASE_URL } from "../../config";
import api from "../../components/commonComponents/axiosSetup";
import { isSuperAdmin } from "../customerManagement/utility/authUtils";

// Fetch inventory data with pagination
export const fetchInventoryData = async (companyId, page = 0, size = 5) => {
  try {
    if (companyId === null || companyId === "null" || companyId === "" || companyId == null) {
      companyId = null;
    }

    const isSuperAdmin = localStorage.getItem("isSuperAdmin") === "true";
    
    const url = companyId
      ? `${BASE_URL}api/management/page/account/${companyId}?page=${page}&size=${size}`
      : `${BASE_URL}api/management300/getAll?page=${page}&size=${size}`;

    const response = await api.get(url, {
      headers: {
        isSuperAdmin: isSuperAdmin.toString()
      }
    });
    
    const result = response.data.body;
    const paginationInfo = {
      pageNumber: response.data.pageNumber,
      pageSize: response.data.pageSize,
      totalPages: response.data.totalPages,
      totalElements: response.data.totalElements
    };

    const mappedData = result.map((item) => ({
      id: item.id,
      iccid: item.iccid,
      msisdn: item.msisdn,
      imsi: item.imsi,
      allocatedTo: item.allocatedTo || "",
      simType: item.simType,
      simState: item.simState,
      profileType: item.profileType,
      deviceType: item.deviceType,
      deviceModel: item.deviceModel || "",
      deviceId: item.deviceId,
      account: item.accountName,
      activationDate: item.activationDate
        ? dayjs(item.activationDate).format("DD/MM/YYYY")
        : "NA",
      planId: item.planId || "",
      profile: item.availableProfiles || "",
      validity: item.validUpto
        ? (() => {
            let datePart = item.validUpto.split("T")[0];
            let parts = datePart.split("-");
            return parts[2] + "/" + parts[1] + "/" + parts[0];
          })()
        : "",
      companyId: item.companyId,
      relationKey: item.relationKey,
      DatawhitelistGroup: item.dataWhitelistGroup || "N/A",
      SMSwhitelistGropupName: item.smsWhitelistGroup || "N/A",
      activationDateFrom: item.activationDateFrom,
      activationDateTo: item.activationDateTo,
      euccid: item.euccid || "",
      serialNo: item.serialNo || "",
      vendor: item.vendor || "",
      masterRequestId: item.masterRequestId || "",
      kycStatus:item.kycStatus || ""  ,
      kycMasterRequestId:item.kycMasterRequestId || ""

    }));

    return {
      data: mappedData,
      pagination: paginationInfo
    };
  } catch (err) {
    console.error("Failed to fetch inventory data:", err);
    throw err;
  }
};
export const getOptions = async (companyId) => {
  try {
    if (!companyId || companyId === "null") {
      companyId = null;
    }

    const url = companyId
      ? `${BASE_URL}api/management/account/${companyId}`
      : `${BASE_URL}api/management300/getAll`;

    const response = await api.get(url);
    const result = response.data.body;

    // Map only required fields
    const mappedData = result.map((item) => ({
      iccid: item.iccid,
      msisdn: item.msisdn,
      allocatedTo: item.allocatedTo || "",
      simType: item.simType,
      simState: item.simState,
      deviceType: item.deviceType,
      accountName: item.accountName,
      vendor: item.vendor || "",
      masterRequestId: item.masterRequestId || "",
      kycMasterRequestId:item.kycMasterRequestId || ""

    }));
console.log("Mapped Data:", mappedData);
    return mappedData;
  } catch (err) {
    console.error("Failed to fetch inventory data:", err);
    throw err;
  }
};
// Fetch filtered data with pagination
export const fetchFilteredData = async (filterPayload, page = 0, size = 10) => {
  try {
    const SuperAdmin = isSuperAdmin();
    const accountId = localStorage.getItem("userId");

    const response = await api.post(
      `${BASE_URL}api/management/actual/filter-data?page=${page}&size=${size}`,
      filterPayload,
      {
        headers: {
          isSuperAdmin: SuperAdmin.toString(),
          accountId: accountId,
          "Content-Type": "application/json"
        }
      }
    );

    const result = response?.data?.body;
    const paginationInfo = {
      pageNumber: response.data.pageNumber,
      pageSize: response.data.pageSize,
      totalPages: response.data.totalPages,
      totalElements: response.data.totalElements
    };
if(result==null || result.length===0){
  alert("No data found for the applied filters")
  return null;
}
    const mappedData = result.map((item) => ({
      id: item.id,
      iccid: item.iccid,
      msisdn: item.msisdn,
      imsi: item.imsi,
      allocatedTo: item.allocatedTo || "",
      simType: item.simType,
      simState: item.simState,
      profileType: item.profileType,
      deviceType: item.deviceType,
      deviceModel: item.deviceModel || "",
      deviceId: item.deviceId,
      account: item.accountName,
      activationDate: item.activationDate
        ? dayjs(item.activationDate).format("DD/MM/YYYY")
        : "NA",
      planId: item.planId || "",
      profile: item.availableProfiles || "",
      validity: item.validUpto
        ? (() => {
            let datePart = item.validUpto.split("T")[0];
            let parts = datePart.split("-");
            return parts[2] + "/" + parts[1] + "/" + parts[0];
          })()
        : "",
      companyId: item.companyId,
      relationKey: item.relationKey,
      DatawhitelistGroup: item.dataWhitelistGroup || "N/A",
      SMSwhitelistGropupName: item.smsWhitelistGroup || "N/A",
      activationDateFrom: item.activationDateFrom,
      activationDateTo: item.activationDateTo,
      euccid: item.euccid || "",
      serialNo: item.serialNo || "",
      vendor: item.vendor || "",
      masterRequestId: item.masterRequestId || "",
      kycStatus:item.kycStatus || ""  ,
      kycMasterRequestId:item.kycMasterRequestId || ""
    }));

    return {
      data: mappedData,
      pagination: paginationInfo
    };
  } catch (err) {
    console.error("Failed to fetch filtered data:", err);
    throw err;
  }
};

export const fetchPlansAndGroupByAccount = async (companyId = 13) => {
  try {
    const response = await api.get(`${BASE_URL}apis/plans`);

    const plans = Array.isArray(response.data) ? response.data : [response.data];
    const grouped = {};

    plans.forEach((plan) => {
      const {
        id,
        planName,
        dataAllowance,
        dataUnit,
        smsAllowance,
        smsUnit,
        amount,
        currency,
        validity,
        accountNames,
        planType
      } = plan;

      if (!Array.isArray(accountNames) || accountNames.length === 0) {
        console.warn("Invalid accountNames for plan:", planName);
        return;
      }

      accountNames.forEach((account) => {
        if (!grouped[account]) grouped[account] = [];

        grouped[account].push({
          planName,
          data: dataAllowance && dataUnit ? `${dataAllowance}` : "N/A",
          sms: smsAllowance && smsUnit ? `${smsAllowance} ` : "N/A",
          cost: amount && currency ? `₹${amount}` : "N/A",
          Valid_Upto: validity || "N/A",
          id: id,
          planType: planType || "N/A"
        });
      });
    });

    return grouped;
  } catch (error) {
    console.error("Failed to fetch plan details", error);
    return {};
  }
};

export const updateSimStates = async (payload) => {
  try {
    const response = await api.put(
      `${BASE_URL}api/management/updateStates`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update sim states", error);
    throw error;
  }
};

export const activateSimsWithWhitelisting = async (payload) => {
  try {
    const response = await api.post(
      `${BASE_URL}api/sim-management/upload`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to activate sims with whitelisting", error);
    throw error;
  }
};

export const KycOperation = async (payload) => {
  try {
    const response = await api.post(
      `${BASE_URL}api/sim-management/process`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to activate sims with whitelisting", error);
    throw error;
  }
};

export const TopUP = async (payload) => {
  const token = localStorage.getItem("authToken");
  const companyId = localStorage.getItem("userId");

  try {
    const response = await api.post(
       `${BASE_URL}api/management/operation`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          accountId: companyId

        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Failed to activate sims with whitelisting", error);
    throw error;
  }
};


export const saveSimState = async (primaryIccid, primaryDeviceId, associatedSecondaryIccid = null, secondaryDeviceId = null) => {
  try {
    const payload = [{
      iccid: primaryIccid,
      deviceId: primaryDeviceId
    }];

    if (associatedSecondaryIccid) {
      payload.push({
        iccid: associatedSecondaryIccid,
        deviceId: primaryDeviceId || ""
      });
    }

    const response = await api.put(
      `${BASE_URL}api/management/updateStates`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Failed to save sim state", error);
    throw error;
  }
};

export const bulkUploadInventory = async (file, simType) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("simType", simType);

    const response = await api.post(
      `${BASE_URL}api/management/read/excel`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    const result = response?.data?.body?.foundData || response?.data;
    const alert = response?.data?.body || 'Upload successful';

    const mappedData = result.map((item) => ({
      id: item.id,
      iccid: item.iccid,
      msisdn: item.msisdn,
      imsi: item.imsi,
      allocatedTo: item.allocatedTo || "",
      simType: item.simType,
      simState: item.simState,
      profileType: item.profileType,
      deviceType: item.deviceType,
      deviceModel: item.deviceModel || "",
      deviceId: item.deviceId,
      account: item.account,
      activationDate: item.activationDate
        ? dayjs(item.activationDate).format("DD/MM/YYYY")
        : "NA",
      planId: item.planId || "",
      validity: item.validUpto || "",
      companyId: item.companyId,
      relationKey: item.relationKey,
      activationDateFrom: item.activationDateFrom,
      activationDateTo: item.activationDateTo,
      euccid: item.euccid || "",
      serialNo: item.serialNo || "",
      vendor: item.vendor || "",
    }));

    return {
      success: true,
      data: mappedData,
      message: `Successfully uploaded ${mappedData.length} records`,
      alert: alert
    };

  } catch (err) {
    console.error("Failed to bulk upload inventory:", err);

    const errorMessage = err.response?.data?.message || err.message || "Upload failed";

    return {
      success: false,
      data: [],
      message: errorMessage
    };
  }
};

export const GetExcel = async (filterPayload) => {
  try {
    const SuperAdmin = isSuperAdmin();
    const accountId = localStorage.getItem("userId");

    const response = await api.post(
      `http://192.168.30.45:7078/api/management/download`,
      filterPayload,
      {
        responseType: "blob", // 👈 EXPECT EXCEL FILE
        headers: {
          isSuperAdmin: SuperAdmin.toString(),
          accountId: accountId,
          "Content-Type": "application/json",
          "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // 👈 REQUEST EXCEL
        },
      }
    );

    // Create Excel file from backend response
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "filtered_inventory.xlsx"; // default file name
    link.click();
    window.URL.revokeObjectURL(url);

    return true; // success flag

  } catch (err) {
    console.error("Failed to fetch excel file:", err);
    alert("Failed to download Excel");
    return false;
  }
};
